import React, { Component } from 'react';
import { Trans } from "react-i18next";

import { NavLink } from 'react-router-dom';
// import { Modal, ModalHeader, ModalBody } from 'reactstrap';
//import Swiper from 'react-id-swiper';
import axios from 'axios';
//import Cookies from 'universal-cookie';
import SideBar from "./SideBar";
import SideNav from "react-simple-sidenav";
import "../../config/i18n";
import { withTranslation } from "react-i18next";

import ls from "local-storage";
import { options } from "../../config/options";
//import {creditimg} from "../../assets/img/sub-3.png";
const creditimg = require('../../assets/img/wallet.png');

class WalletHistory extends Component {

    constructor(props) {
        super(props);
        this.loggedIn = sessionStorage.getItem('loggedin');
        this.getSessionDetails = this.getSessionDetails.bind(this)

        this.state = {
            credits: '0',
            api_url: localStorage.getItem('api_url'),
            showNav3: false, user_details: '',
            history: [],
            lang: ls.get('LangKeySet') || options[0],
            langKey: ls.get('LangValue'),
            nodata: false,
            clas1: '', clas2: '', clas3: '', clas4: '', clas5: '', txt1: '', txt2: '',
            userDetails:{}
        }

    }
    addDefaultSrc(ev) {
        ev.target.src = require('../../assets/img/howzu-logo-default.png')
    }

    async getSessionDetails(){
        try {
            let url = this.state.api_url + "webprofile";
            let data = new FormData();
            data.append(
              "user_id",
              JSON.parse(localStorage.getItem("session_userid"))
            );
            data.append("language", this.state.langKey);
            axios.defaults.headers.common["Authorization"] = JSON.parse(
              localStorage.getItem("session_token")
            );
            let options = { headers: { "Content-Type": "multipart/form-data" } };
            let user = await axios.post(url, data, options);
            this.setState({
              userDetails: user.data.result,
            });
          } catch (error) {
            console.log(error);
          }
    }
    componentDidMount() {
        //  var userid = JSON.parse(localStorage.getItem('session_userid'));
        //  if(userid == '' || userid == null){
        //      alert("userid");
        //  }
        // this.getSessionDetails();
        var datalist = new FormData();
        datalist.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
        datalist.set('language', this.state.langKey);

        axios({
            method: 'post',
            url: this.state.api_url + 'wallethistory',
            data: datalist,
            config: {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
                }
            }
        }).then(res => {
            if (res.data.status === 'true') {
                console.log("data=" + JSON.stringify(res.data, null, 4));
                // const credits = "100";
                // console.log({credits});
                //console.log("rrrrr",res.data.result.user_name,"rty",res.data.result.images);
                this.setState({
                    history: [...res.data.result]
                });
                console.log("history=" + this.state.history);


            } else {

                this.setState({
                    nodata: true, clas1: 'noItemsContainers', clas2: 'visitorsNull', clas3: 'nullVisitors nullSize', clas4: 'text-dark bold-font text-center apk-20', clas5: 'secondaryText apk-16 regular-font text-center', txt1: 'No Visitors', txt2: 'Update the Filters!'
                });

                // this.props.history.push("/login");   
            }
        }).catch(error => {
            this.props.history.push("/login");
        });

        // axios.get(this.state.api_url+`admindatas`)
        //   .then(res => {
        //     const items = res.data.result.peoplefor;
        //     // console.log(res.data);
        //     this.setState({ items });
        //   })
        //   var premiumlist = new FormData();
        //   premiumlist.set('platform', 'web');
        //   premiumlist.set('language', this.state.langKey); 
        //   axios({
        //     method: 'post',
        //     url: this.state.api_url+'premiumlistweb',
        //     data: premiumlist,
        //     config: { headers: {'Content-Type': 'multipart/form-data' }}
        //       })
        //       .then(res => {
        //         const data = res.data;
        //        // console.log("premium list",res.data);
        //         this.setState({
        //           itemss: data.result,
        //           activeItems: data.result[0].id,
        //           selected_premium: data.result[0].id,
        //           premium_price: data.result[0].price,
        //           permium_superlikeCount: data.result[0].superlikecount, 
        //           permium_boostCount: data.result[0].boostcount,   
        //           currency: data.currency,
        //           payment: data.payment,
        //           license_key: data.license_key,
        //       });
        //       localStorage.setItem('selected_premium',JSON.stringify(this.state.selected_premium));
        //       localStorage.setItem('premium_price',JSON.stringify(this.state.premium_price));
        //       localStorage.setItem('currency',JSON.stringify(this.state.currency));
        //       });


    }


    render() {
        const params = {
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            spaceBetween: 1,
            rebuildOnUpdate: true
        }

        const params2 = {
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            slidesPerView: 3,
            slidesPerColumn: 1,
            breakpoints: {
                360: {
                    slidesPerView: 3,
                },
                359: {
                    slidesPerView: 2,
                }
            }
        };

        return (

            <div className="setting-page">

                <div className="d-flex profile-header-top stickyProfileHead justify-content-between apd15 apr0 apl0 white-bg ">
                    <div className="heading-left-top d-flex">
                        <div className="align-self-center ">
                            <div className="iconHolder align-self-center mr-1">
                                <div className="backGlow  d-block d-lg-none">
                                    <div className="backIco" onClick={() => this.setState({ showNav3: true })}></div>
                                </div>
                                <NavLink to={"/app/wallet"} >
                                    <div className="backGlow  d-block nonResp">
                                        <div className="backIco"></div>
                                    </div>
                                </NavLink>
                            </div>
                        </div>
                        <span className="arrow-center align-self-center ml-1 bold-font"><Trans i18nKey="Wallet History">Wallet History</Trans>
                        </span>
                    </div>
                    <div className="backGlow white-bg"></div>


                </div>


                {this.state.nodata === false ? <div className="wallethistory">

                    {this.state.history.map((data, index) =>
                        <div key={index}>
                            <div className="apd0 apl75 apt0" >
                                {(this.state.langKey == 'ar' && (data.title == "Referral signup" || data.title == "Referral invite" )) ? (
                                    <p className="custom_p" style={{ "direction": "ltr" }} >{data.messageweb}</p>
                                ) : (
                                    <p className="custom_p">{data.message}</p>
                                )
                                }
                                <span className="custom_font">{data.date_time}</span>
                            </div>
                            <hr />
                        </div>
                    )}




                </div> : <div className={this.state.clas1}>

                    <div class={this.state.clas2}>
                        <div className={this.state.clas3}></div>
                        <div className={this.state.clas4}><Trans i18nKey="No wallet history">No wallet history</Trans></div>
                    </div>

                </div>}


                <div className="sidebarResp d-block d-lg-none">
                    <SideNav showNav={this.state.showNav3} onHideNav={() => this.setState({ showNav3: false })} title={<div></div>} items={[<SideBar />]} />
                </div>











            </div>
        )
    }
}

export default withTranslation("translations")(WalletHistory);